import { ArrayEntitieFields } from "./ArrayEntityFields";
import { eEntity } from "./eEntity";
import { DataType } from './eDataType';
import { EntityField } from "./EntityField";

export class ADN_PLUS {
    ID: string;
    ArrayEntities: ArrayEntitieFields;
    Entity: eEntity;
    EntityInt: number;
    Auditable: boolean;
    AuditableDesc: string;
    PCID: string;

    constructor(obj = null) {
        if (obj)
            obj && Object.assign(this, obj);
        else {
            this.Entity = eEntity.UNKNOWN;
            this.ArrayEntities = new ArrayEntitieFields();
            this.ID = "";
            this.Auditable = false;
            this.PCID = null;
        }
    }


    public getStringAttribute(name: string): string {
        if (!this.ArrayEntities) return null;
        for (let item of this.ArrayEntities.List) {
            if (item.Name == null) item.Name = "";
            if (item.Alias == null) item.Alias = "";
            if (item.Name === name || item.Alias === name)
                return item.Value;
        }

        return null;
    }

    ContainsAttribute(alias: string) {
        return this.ArrayEntities.List.find(att => att.Alias === alias) ? true : false;
    }

    addAttribute(name: string, value: string, type = DataType.VARCHAR2): void {
        this.setAttributeByAlias(name, value, type);
    }

    setStringAttribute(alias: string, value: string, displayValue: string = "", index: number = -1, pName: string = ""): void {
        this.setAttributeByAlias(alias, value, DataType.VARCHAR2, displayValue, index, null, pName);
    }

    setAttributeByAlias(alias: string, value, type = DataType.VARCHAR2, displayValue: string = "", index: number = -1, familyId: string = null, name: string = ""): void {
        var field = new EntityField();
        field.Name = name || name !== "" ? name : alias;
        field.Display = displayValue;
        field.Value = value != null ? value.toString() : null;
        field.Type = type;
        field.Alias = alias;
        field.FamilyId = familyId ? familyId : alias;
        let attributeReplaced = false;

        //Si encuentra la propiedad la modifica, sino la agrega
        for (let item of this.ArrayEntities.List) {
            if (item.Alias === alias) {
                item.Value = field.Value;
                item.Type = field.Type;
                attributeReplaced = true;
            }
        }
        //Cuando no se reemplazo el atributo este se agrega.
        if (!attributeReplaced)
            this.ArrayEntities.List[index == -1 ? this.ArrayEntities.List.length : index] = field;
    }




}